import { toast } from 'react-toastify';
import IconSuccess from '../components/images/IconSuccess.jsx';
import IconError from '../components/images/IconError.jsx';
import IconInfo from '../components/images/IconInfo.jsx';

const useSuccessToast = (message) => {
    toast.success('', {
        position: 'top-center',
        icon: <IconSuccess className='w-8 h-8 fill-theme1-success stroke-theme1-success' />,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
        data: {
            message
        }
    });
};

const useInfoToast = (message) => {
    toast.info('', {
        position: 'top-center',
        icon: <IconInfo className='w-8 h-8 fill-theme1-info stroke-theme1-info' />,
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
        data: {
            message
        }
    });
};

const useErrorToast = (message) => {
    toast.error('', {
        icon: <IconError className='w-8 h-8 fill-theme1-error stroke-theme1-error' />,
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        draggable: false,
        progress: undefined,
        theme: 'light',
        data: {
            message
        }
    });
};

export { useErrorToast, useSuccessToast, useInfoToast };
